module.exports = __webpack_public_path__ + "img/upload-file-accent-icon.aa131403.svg";